import { ErrorMessage, Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormCheck,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import { Texterror } from "../../../constants/Texterror";
import { getSession } from "../../../redux/actions/authActions";
import { citylist } from "../../../redux/actions/dbactions/refactions";
import { Icon } from "@iconify/react";
import { editPatient } from "../../../redux/actions/dbactions/patientActions";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export const EditModal = ({
  show,
  dispatch,
  onHide,
  selectedCountryId,
  setSelectedCountryId,
  setRefresh,
  setEditmodal,
  editData,
}) => {
  const { currentData } = useSelector((state) => state.patientlist);
  const { user_profile_id, role_id } = getSession();
  const { refsdata } = useSelector((state) => state.refstypes);
  const { citis, isLoading: citiesLoading } = useSelector(
    (state) => state.cities
  );
  const [iseditable, setIseditable] = useState(true);
  const handleedit = () => {
    setIseditable(false);
  };
  const [selectedImage, setSelectedImage] = useState(null);
  const [isCountrySelected, setIsCountrySelected] = useState(false);
  const [values, setValues] = useState({ mobile_no: "0000000000" });
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);

    const reader = new FileReader();
    reader.onloadend = () => { };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const [selectedCityId, setSelectedCityId] = useState(null);
  const {
    svcf_name,
    svcf_desc,
    svcf_contact_phone_nbr,
    svcf_contact_email,
    svcf_addr_street1,
    svcf_addr_street2,
    svcf_allow_sms_yn,
    svcf_iso_cntry_id,
    svcf_allow_wup_sms_yn,
    svcf_addr_state,
    svcf_photo,
    svcf_iso_city_id,
    svcf_id,
  } = currentData;
  const facilityTypes = refsdata.usr?.service_facility_type || [];
  // State for dropdowns
  const [selectedGender, setSelectedGender] = useState(
    currentData.gender_id === 1 ? "Male" : "Female"
  );
  const [selectedCity, setSelectedCity] = useState(
    currentData.user_iso_city_name
  );
  const [selectedCountry, setSelectedCountry] = useState(
    currentData.user_iso_cntry_name
  );

  //facilityTypes Change
  const handleFacilityTypeChange = (event, setFieldValue) => {
    const selectedFacilityType = event.target.value;

    const selectedFacilityTypeObject = facilityTypes.find(
      (item) => item.svcft_typ_id === selectedFacilityType
    );

    setFieldValue("svcf_type_id", selectedFacilityType);
    setFieldValue("svcft_typ_id", selectedFacilityType);
  };
  //country handle change
  const handleCountryChange = (event, setFieldValue) => {
    const newSelectedCountryId = event.target.value;

    // Update selectedCountryId state
    setSelectedCountryId(newSelectedCountryId);

    // Dispatch citylist action
    dispatch(citylist(newSelectedCountryId));

    if (newSelectedCountryId) {
      setIsCountrySelected(true);
    } else {
      setIsCountrySelected(false);
    }

    setFieldValue("svcf_iso_cntry_id", newSelectedCountryId);
  };
  //city handle change
  const handleCityChange = (event, setFieldValue) => {
    const selectedCityId = event.target.value;

    setSelectedCityId(selectedCityId);
    setFieldValue("svcf_addr_state", selectedCityId);
    setFieldValue("svcf_iso_city_id", selectedCityId);
  };

  return (
    <Modal className="edit_modal profile" show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <h5 className="mb-0">{`Edit Patient Details`}</h5>
      </Modal.Header>
      <Modal.Body>
        <div className="profile">
          <div className="card_white_box">
            <h5 className="globale-title">
              <span>Patient Profile</span>
              {iseditable ? (
                <p className="mb-0" onClick={handleedit}>
                  <Icon icon="ci:note-edit" />
                  <span>Edit</span>
                </p>
              ) : null}
            </h5>
            <Formik
              initialValues={{
                user_first_name: currentData.user_first_name,
                user_last_name: currentData.user_last_name,
                user_email: "n/a",
                mobile_no: currentData.user_phone_nbr,
                address: currentData.addr_street1,
              }}
              onSubmit={async (values) => {
                const { token, user_profile_id, role_id } = getSession();
                values = {
                  ...values,
                  svcuser_reqstr_user_id: 34,
                  ethncty_id: 3,
                  gender_id: 1,
                  svc_rel_id: null,
                  user_id_nbr: "JD123",
                  addr_iso_city_id: 147912,
                  sys_user_id: user_profile_id,
                  role_id: role_id,
                };
                dispatch(editPatient(values, user_profile_id));
                setRefresh();
                onHide();

                setIseditable(true);
              }}
            >
              {({ touched, errors, values, setFieldValue, handleSubmit }) => (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Field
                          className={`form-control ${touched.user_first_name && errors.user_first_name
                              ? "is-invalid"
                              : ""
                            }`}
                          name="user_first_name"
                          type="input"
                          value={values.user_first_name}
                          disabled={iseditable}
                        />
                        <ErrorMessage
                          name="user_first_name"
                          component={Texterror}
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Field
                          className={`form-control ${touched.user_last_name && errors.user_last_name
                              ? "is-invalid"
                              : ""
                            }`}
                          name="user_last_name"
                          type="input"
                          value={values.user_last_name}
                          disabled={iseditable}
                        />
                        <ErrorMessage
                          name="user_last_name"
                          component={Texterror}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Field
                          className={`form-control ${touched.user_email && errors.user_email
                              ? "is-invalid"
                              : ""
                            }`}
                          name="user_email"
                          type="email"
                          value={values.user_email}
                          disabled
                        />
                        <ErrorMessage name="user_email" component={Texterror} />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Form.Label>Phone Number</Form.Label>
                        <PhoneInput
                          country={"auto"}
                          value={values.mobile_no}
                          onChange={(phone) => setValues({ mobile_no: phone })}
                          enableAreaCodes={true}
                          enableSearch={true}
                          disableSearchIcon={true}
                          autoFormat={true}
                          inputClass={`form-control ${touched.mobile_no && errors.mobile_no
                              ? "is-invalid"
                              : ""
                            }`}
                          disabled={iseditable}
                        />
                        <ErrorMessage name="mobile_no" component={Texterror} />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="mb-3">
                        <Form.Label>Address</Form.Label>
                        <Field
                          className={`form-control ${touched.address && errors.address
                              ? "is-invalid"
                              : ""
                            }`}
                          name="address"
                          type="input"
                          placeholder="Address"
                          value={values.address}
                          disabled={iseditable}
                        />
                        <ErrorMessage name="address" component={Texterror} />
                      </div>
                      <div className="mb-3">
                        <Field
                          className={`form-control ${touched.street1 && errors.street1
                              ? "is-invalid"
                              : ""
                            }`}
                          name="street1"
                          placeholder="Address line 1"
                          type="input"
                          value={values.street1}
                          disabled={iseditable}
                        />
                        <ErrorMessage name="street1" component={Texterror} />
                      </div>
                      <div className="mb-3">
                        <Field
                          className={`form-control ${touched.street2 && errors.street2
                              ? "is-invalid"
                              : ""
                            }`}
                          name="street2"
                          type="input"
                          value={values.street2}
                          placeholder="Address line 2"
                          disabled={iseditable}
                        />
                        <ErrorMessage name="street2" component={Texterror} />
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col lg={4}>
                      <div className="mb-3">
                        <Form.Select
                          className="form-control"
                          name="facility_select"
                          aria-label="Default select example"
                          disabled={iseditable}
                          value={selectedCountry} // Set the value attribute to the selected value
                          onChange={(e) => {
                            // Handle city selection here
                          }}
                        >
                          <option value={1}>
                            {currentData.user_iso_cntry_name}
                          </option>
                          <option value="1">India</option>
                        </Form.Select>
                        <ErrorMessage
                          name="facility_select"
                          component={Texterror}
                        />
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="mb-3">
                        <Form.Select
                          className="form-control"
                          name="facility_select"
                          aria-label="Default select example"
                          disabled={iseditable}
                          value={selectedCity}
                        >
                          <option value="1">
                            {currentData.user_iso_city_name}
                          </option>
                          <option value="2">Chicago</option>
                        </Form.Select>
                        <ErrorMessage name="street1" component={Texterror} />
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="mb-3">
                        <Field
                          className={`form-control ${touched.street1 && errors.street1
                              ? "is-invalid"
                              : ""
                            }`}
                          name="street"
                          placeholder="Zip Code"
                          type="input"
                          value={values.street1}
                          disabled={iseditable}
                        />
                        <ErrorMessage name="street1" component={Texterror} />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="op mb-2">
                        <FormCheck
                          name="svc_provider_yn"
                          type="checkbox"
                          disabled={iseditable}
                          label="Yes, contact me via SMS"
                        />
                      </div>
                      <div className="op mb-2">
                        <FormCheck
                          name="svc_provider_yn"
                          type="checkbox"
                          disabled={iseditable}
                          label="Yes, contact me via Whatsapp"
                        />
                      </div>
                      {iseditable ? null : (
                        <div className="mini_edit">
                          <button
                            className="sign_btn"
                            onClick={() => setIseditable(true)}
                          >
                            Cancelx
                          </button>
                          <button className="sign_btn" type="submit">
                            Save
                          </button>
                        </div>
                      )}
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
